import { render } from "./UsersDetail.vue?vue&type=template&id=40e695c8"
import script from "./UsersDetail.vue?vue&type=script&lang=ts"
export * from "./UsersDetail.vue?vue&type=script&lang=ts"
script.render = render

export default script